module.exports = __webpack_public_path__ + "2f678a12e3d1ad2f1bacc8e1c04a4fb2.png";